import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import api from "@/lib/api";

export const VAL_STATUS_STYLE = {
  "En attente de validation": "bg-amber-100 text-amber-800", "En cours de validation": "bg-sky-100 text-sky-800",
  "Approuvée": "bg-emerald-100 text-emerald-800", "Rejetée": "bg-rose-100 text-rose-800",
  "Correction demandée": "bg-orange-100 text-orange-800", "Annulée": "bg-slate-200 text-slate-600", "Brouillon": "bg-slate-100 text-slate-600",
};
export const VAL_STATUSES = Object.keys(VAL_STATUS_STYLE).filter((s) => s !== "Brouillon");

export const ValStatus = ({ s, testid }) => (
  <span className={`inline-block rounded-full px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap ${VAL_STATUS_STYLE[s] || "bg-slate-100"}`} data-testid={testid}>{s}</span>
);

const SHORT = { "En attente de validation": "En attente", "En cours de validation": "En cours" };
export const ValBadge = ({ v }) => (!v?.id ? null : (
  <Link to={`/validations/demande/${v.id}`} onClick={(e) => e.stopPropagation()} title={`Validation ${v.numero} : ${v.statut}`}
    className={`mt-0.5 inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[10px] font-semibold whitespace-nowrap hover:underline ${VAL_STATUS_STYLE[v.statut] || "bg-slate-100"}`} data-testid={`val-badge-${v.id}`}>
    <ShieldCheck className="h-3 w-3" />{SHORT[v.statut] || v.statut} · {v.numero}
  </Link>
));

export const fmtDelay = (h) => (h == null ? "—" : h < 24 ? `${Math.round(h)} h` : `${Math.floor(h / 24)} j ${Math.round(h % 24)} h`);

export function useValMeta() {
  const [meta, setMeta] = useState(null);
  useEffect(() => { api.get("/validations/me").then((r) => setMeta(r.data)).catch(() => setMeta({ perms: [], ops: [] })); }, []);
  return meta;
}
